import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    { key: "conversation_id", label: "conversation_id" },
    { key: "pipeline", label: "pipeline" },
    { key: "platform", label: "platform" }
  ],
};

export default schema;

